<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import FileUpload from '../../Shared/FileUpload.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="form__header">
            {{ t('lan_nafnabeyting_umsokn_step9_header1') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <!-- Tax Return -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.taxReturn"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step9_taxReturn')"
          />
          <transition name="list">
            <div v-if="umsokn.taxReturn">
              <FileUpload
                :umsoknType="11"
                :umsoknId="umsokn.id"
                :filespace="13"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Tax Register -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.taxRegister"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step9_taxRegister')"
          />
          <transition name="list">
            <div v-if="umsokn.taxRegister">
              <FileUpload
                :umsoknType="11"
                :umsoknId="umsokn.id"
                :filespace="14"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Pre Payment -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.prePayment"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step9_prePayment')"
          />
          <transition name="list">
            <div v-if="umsokn.prePayment">
              <FileUpload
                :umsoknType="11"
                :umsoknId="umsokn.id"
                :filespace="15"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Purchase Offer -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.purchaseOffer"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step9_purchaseOffer')"
          />
          <transition name="list">
            <div v-if="umsokn.purchaseOffer">
              <FileUpload
                :umsoknType="11"
                :umsoknId="umsokn.id"
                :filespace="16"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Building Certificate -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.buildingCertificate"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step9_buildingCertificate')"
          />
          <transition name="list">
            <div v-if="umsokn.buildingCertificate">
              <FileUpload
                :umsoknType="11"
                :umsoknId="umsokn.id"
                :filespace="17"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Fixed Payments -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.fixedPayments"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step9_fixedPayments')"
          />
          <transition name="list">
            <div v-if="umsokn.fixedPayments">
              <FileUpload
                :umsoknType="11"
                :umsoknId="umsokn.id"
                :filespace="18"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>

        <!-- Other -->
        <v-col cols="12">
          <v-checkbox
            v-model="umsokn.other"
            :readonly="props.disable"
            :label="t('lan_nafnabeyting_umsokn_step9_other')"
          />
          <transition name="list">
            <div v-if="umsokn.other">
              <FileUpload
                :umsoknType="11"
                :umsoknId="umsokn.id"
                :filespace="20"
                :disable="props.disable"
              />
            </div>
          </transition>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
